<template>
  <div>
    <v-row>
      <v-col cols="12" lg="6" class="my-auto">
        <div style="font-size: 17px" class="indigo--text font-weight-medium">Laporan Pelaksanaan</div>
      </v-col>
      <v-col cols="12" lg="3">
        <div class="body-2 grey--text">Status Laporan</div>
        <v-chip class="white--text" :color="getStatus('color')">{{ getStatus('label') }}</v-chip>
      </v-col>
      <v-col cols="12" lg="3">
        <div :class="['orange--text text--lighten-5']">Aksi</div>
        <v-btn color="primary" depressed class="text-capitalize" @click="onEntryLaporan">
          <v-icon left class="mr-1">{{ !isEdit || !isPeriodeEntry ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
          {{ !isEdit || !isPeriodeEntry ? 'Lihat' : getStatus('value') === 2 ? 'Ubah' : 'Lengkapi' }} Laporan
        </v-btn>
      </v-col>
    </v-row>
    <base-modal-full ref="modal" title="Laporan Pelaksanaan" :useSave="!formulir.isPreview" @save="onSaveLaporan">
      <form-pelaksanaan
        ref="formulir"
        :masters="Object.assign({}, masters)"
        :id="formulir.id"
        :laporan="formulir.laporan"
        :is-preview="formulir.isPreview"
        :is-entry="isPeriodeEntry"
        :is-login-ks="isLoginKs"
        :pendampingan-ke="pendampinganKe"
        :psp-kp-pa="pspKpPa"
        :detail="isPeriodeEntry ? detail : $isObject(detailMeta['laporan_topik']) ? detailMeta['laporan_topik'] : {}"
        :meta="meta"
        :pelaksana="pelaksana"
        @refresh="onRefresh"
      />
    </base-modal-full>
  </div>
</template>
<script>
import FormPelaksanaan from '../forms/FormPelaksanaan.vue';
import { mapActions } from 'vuex';

export default {
  name: 'LaporanPelaksanaan',
  components: { FormPelaksanaan },
  props: {
    isEdit: {
      type: Boolean,
      default: true,
    },
    pelaksana: {
      type: Object,
      default: () => {},
    },
    pspKpPa: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    pendampinganKe: {
      type: [Number, String],
      default: '',
    },
    pspKpPaId: {
      type: [Number, String],
      default: '',
    },
    detail: {
      type: Object,
      default: () => {},
    },
    detailMeta: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isLoginKs: {
      type: Boolean,
      default: true,
    },
    isPeriodeEntry: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    sekolah() {
      return this.pelaksana.sekolah || {};
    },

    statusLengkap() {
      const dataMeetingPmo = this.$getDeepObj(this.detail, 'data_meeting_pmo') || [];
      const dataPelaksanaan = this.detail.tgl_pelaksanaan_pmo && this.detail.jml_peserta_pmo;
      const status = this.detail.status_lengkap || {};

      if (!this.$isObject(status)) {
        return status;
      }

      return Object.assign({}, status, { pmo: dataPelaksanaan, rekaman: dataMeetingPmo.length > 0 });
    },

    isTerlaksana() {
      const tglPmo = this.detail.tgl_pelaksanaan_pmo || '';
      const jmlPmo = this.detail.jml_peserta_pmo || '';
      const berkas = this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_laporan_berkases.data') || [];
      const instrumen = this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_laporan_instrumens.data') || [];

      return !!tglPmo || !!jmlPmo || berkas.length > 0 || instrumen.length > 0;
    },
  },
  methods: {
    ...mapActions('laporan', ['save']),

    getStatus(type) {
      let status = { label: 'Tidak ada', color: 'orange', value: 0 };

      if (!this.$isObject(this.detail || {})) {
        return status[type];
      }

      const lengkapKs = ['pmo', 'instrumen', 'berkas'];
      const lengkapFsp = ['pmo', 'instrumen', 'rekaman'];

      const isLengkapPmo = this.detail.is_lengkap === 1;
      let isBelumLengkapPelaksanaan =
        [...[], ...(this.isLoginKs ? lengkapKs : lengkapFsp)].filter((key) => !this.statusLengkap[key]).length > 0;

      if (isLengkapPmo || !isBelumLengkapPelaksanaan) {
        status = { label: 'Lengkap', color: 'green', value: 2 };
      } else if (this.isTerlaksana) {
        status = { label: 'Dalam pengerjaan', color: 'blue', value: 1 };
      }

      return status[type];
    },

    onEntryLaporan() {
      this.$set(this.formulir, 'isPreview', !this.isPeriodeEntry || !this.isEdit);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onRefresh() {
      this.$emit('reload', this.meta?.sekolah ?? {}, { reset: true });
    },

    onSaveLaporan() {
      const params = Object.assign(
        { pendampingan_ke: this.pendampinganKe, grup: 'awal' },
        this.$refs.formulir.getValue()
      );

      let endpoint = `pendampingan-ks/${this.pspKpPa.psp_kp_pa_id}/pelaksana/${this.pelaksana.psp_pelaksana_id}/update-laporan`;
      if (!this.isLoginKs) {
        endpoint = `pendampingan-pa/${this.meta.psp_kp_pa_pendampingan_id}/update-laporan/${this.meta.psp_kp_pa_sekolah_id}`;
      }

      this.save({ endpoint, params })
        .then(() => {
          this.onRefresh();
          this.$success('Laporan berhasil disimpan');
          this.$refs.modal.dialog = false;
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
